import { authAxios } from "src/libs/axios/authAxios";
import { IResetPasswordReq } from "./types/papi.type";
import { basicAxios } from "src/libs/axios/basicAxios";

export const getCloudTime = async (): Promise<any> => {
  const response = await authAxios.get(`/papi/cloud/time`);
  return response;
};

export const passwordInit = async (req: IResetPasswordReq): Promise<any> => {
  const response = await basicAxios.post(`/papi/password/init`, req);
  return response;
};
